import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import { AppService } from '@irb/app.service';
import { IrbAppEvents } from '@irb-common/events';
import { IAlertDialogData } from '@irb/app.model';

@Component({ standalone: false,
  selector: 'irb-com-treatment-options',
  templateUrl: './com-treatment-options.component.html',
  styleUrls: ['./com-treatment-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComTreatmentOptionsComponent implements OnInit {
  @Output() change = new EventEmitter<boolean>();
  @ViewChild('reinvestUnsupportedConfigMessage') reinvestUnsupportedConfigMessage: TemplateRef<any>;

  _data: any;
  _isExternalAcct: boolean = false;

  constructor(private as: AppService) { }

  ngOnInit() {
    this.isExternalAcct = (this.data && this.data.accountsubType && this.data.accountsubType === "EXTERNAL");
  }

  onInputChange() {
    this.change.emit(true);
  }

  validateReinvestChange() {
    const isReinvestValid = !(this.data.isDividendReinvest === true && this.data.isCapGainsReinvest === false);

    if(!isReinvestValid) {
      this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
        msg: "You have selected an unsupported reinvestment election.",
        altMsgTemplate: this.reinvestUnsupportedConfigMessage,
        dType: "WARN"
      } as IAlertDialogData);

      setTimeout(() => {
        this.data.isCapGainsReinvest = true;
        this.onInputChange();
      });
    } else {
      this.onInputChange();
    }
  }

  @Input()
  get data(): any {
    return this._data;
  }

  set data(d: any) {
    this._data = d;
  }

  get isExternalAcct() {
    return this._isExternalAcct;
  }

  set isExternalAcct(isExtAct: boolean) {
    this._isExternalAcct = isExtAct;
  }
 }
